class ReadMore {
    constructor (theme, elem) {
        this._name = this.constructor.name
        this._theme = theme
        this._elem = elem
        this._maxHeight = parseInt(elem.getAttribute('data-read-more')) > 0 ? parseInt(elem.getAttribute('data-read-more')) : 350
        this._open = false
        this._button = null
        this._readmore = elem.querySelector('input.more').value
        this._readless = elem.querySelector('input.less').value
    }

    onInit () {
        if (this._elem.offsetHeight > this._maxHeight) {
            this._elem.style.maxHeight = this._maxHeight + 'px'
            this._elem.classList.add('js-readmore')
            this._button = document.createElement('span')
            this._button.classList.add('js-readmore__button')
            this._button.innerHTML = this._readmore
            this._button.addEventListener('click', () => { this.handleClick() })
            this._elem.parentNode.insertBefore(this._button, this._elem.nextSibling)
        }
    }
    handleClick () {
        if (this._open) {
            this._elem.classList.remove('js-readmore--open')
            this._button.innerHTML = this._readmore
            this._open = false
        } else {
            this._elem.classList.add('js-readmore--open')
            this._button.innerHTML = this._readless
            this._open = true
        }
    }
}

export default ReadMore



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ReadMore.js